import WorkerApiService from "../../workerApiServices";

class FichaDeEstoqueService extends WorkerApiService {
 
    constructor() {
        super('/api/fichaDeEstoque')
    }

    getFichaDeEstoqueByDateInterval(obj){
        return this.post("/searchByDateInterval", obj)
    }

    delete(fichaDeEstoqueToDelete){
        let finalObj = {
            idFichaDeEstoque: fichaDeEstoqueToDelete.id
        }
        return this.post("/delete", finalObj)
    }

    update(obj){
        return this.put("/update", obj)
    }

    detalhamento(body){
        return this.post("/detalhamento", body)
    }
    
}

export default FichaDeEstoqueService